import createContextFetchLoader from '../contextFetch/Loader';
import TenantThemeContext from './Context';
import useTenantTheme from './index';
export var TenantThemeLoader = createContextFetchLoader({
  fetchHook: useTenantTheme,
  FetchContext: TenantThemeContext
});
export default TenantThemeLoader;